import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { UserNotificationViewModel } from 'src/app/models/viewmodels';
import { addIcons } from 'ionicons';
import { closeOutline, alertCircle, checkmarkCircle, closeCircle } from 'ionicons/icons';

@Component({
  standalone: true,
  selector: 'user-notification',
  templateUrl: './user-notification.component.html',
  styleUrls: ['./user-notification.component.scss', '../../../app.component.scss', '../../../../global.scss'],
  imports: [IonicModule]
})
export class UserNotificationComponent  implements OnInit {

  @Output() closeUserNotification = new EventEmitter();
  @Output() openUserNotification = new EventEmitter();
  @Input() userNotification: UserNotificationViewModel = { Title: 'test', SubTitle: 'test', Notification: 'test', NotificationType: 'info' }; 

  constructor() {
    //console.log('user-notification', 'constructor', 'userId');
    addIcons({
      closeOutline,
      alertCircle,
      checkmarkCircle,
      closeCircle
    });
  }

  ngOnInit() {
    if(this.userNotification && !this.userNotification.NotificationType) {
      this.userNotification.NotificationType = 'info';
    }
  }

  onUserNotificationClose() {
    //console.log('user-notification', 'onUserNotificationClose', this.userNotification);
    this.closeUserNotification.emit();
  }

  showUserNotification(userNotification: UserNotificationViewModel){
    //console.log('user-notification', 'showUserNotification', this.userNotification, userNotification);
    this.userNotification = userNotification;
  }

}
